<script lang="ts" setup>
defineProps<{
  article: Article.Detail
}>()

const { scrollBottom } = useScrollState()

function goToComment() {
  const el = document.getElementById('comment')
  if (el) {
    window.scrollTo({
      top: el.offsetTop - 64,
      behavior: 'smooth'
    })
  }
}
</script>

<template>
  <div class="m-article-side-action">
    <div class="m-article-side-action-item">
      <m-like-action
        :resource-id="article.article.id"
        :resource-type="0"
        :like-status="article.like_status"
        type="like"
        vertical
      >
        <span class="text">
          {{ pipe.num(article.like_status.like.count) || '喜欢' }}
        </span>
      </m-like-action>
    </div>
    <div class="m-article-side-action-item">
      <m-like-action
        :resource-id="article.article.id"
        :resource-type="0"
        :like-status="article.like_status"
        type="dislike"
        vertical
      >
        <span class="text">
          {{ pipe.num(article.like_status.dislike.count) || '不喜欢' }}
        </span>
      </m-like-action>
    </div>
    <div class="m-article-side-action-item">
      <m-reward-action
        :resource-id="article.article.id"
        :resource-type="0"
        vertical
      >
        <span class="text">
          {{ pipe.num(article.reward_count) || '打赏' }}
        </span>
      </m-reward-action>
    </div>
    <div class="m-article-side-action-item">
      <m-favorite-action
        :resource-id="article.article.id"
        :resource-type="0"
        vertical
      >
        <span class="text">
          {{ pipe.num(article.favorite_count) || '收藏' }}
        </span>
      </m-favorite-action>
    </div>
    <div class="m-article-side-action-item" @click="goToComment">
      <m-icon icon="ni ni-comment" vertical>
        <span class="text">
          {{ pipe.num(article.floor_num) || '评论' }}
        </span>
      </m-icon>
    </div>
    <div class="m-article-side-action-item">
      <m-forward-action
        :resource-id="article.article.id"
        :resource-type="0"
        vertical
      >
        <span class="text">转发</span>
      </m-forward-action>
    </div>
    <div class="m-article-side-action-item">
      <m-report-action
        :resource-id="article.article.id"
        :resource-type="0"
        vertical
      >
        <span class="text">举报</span>
      </m-report-action>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-article-side-action {
  position: fixed;
  top: 92px;
  color: #393939;
  &-item {
    padding: 8px;
    width: 64px;
    height: 64px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .m-icon {
      font-size: 24px;
      cursor: pointer;
    }
    .text {
      margin-top: 8px;
      font-size: 12px;
    }
  }
}
</style>
